import AppDispatcher from '../utils/AppDispatcher';

import { actions as ActionTypes } from '../constants/NotificationConstants';

var NotificationActions = {

    debouncedNotification: _.debounce(((note) => {
        note.uuid = uuid();
        note.show = true;
        note.timestamp = moment();
        note.additionalInfo = false;

        if (!note.hasOwnProperty('type'))
            note.type = 'success';

        if (!note.hasOwnProperty('sticky'))
            note.sticky = note.type === 'error' ? true : false;

        if (!note.hasOwnProperty('timer') || note.timer === false)
            note.timer = 3000;

        if (!note.hasOwnProperty('fullscreen'))
            note.fullscreen = false;

        Promise.resolve().then(() => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.ADD_NOTIFICATION,
                data: note,
            });
        });
    }), 120000, { leading: true, trailing: false}),

    addNotification:(note) => {
        note.uuid = uuid();
        note.show = true;
        note.timestamp = moment();
        note.additionalInfo = false;

        if (!note.hasOwnProperty('type'))
            note.type = 'success';

        if (!note.hasOwnProperty('sticky'))
            note.sticky = note.type === 'error' ? true : false;

        if (!note.hasOwnProperty('timer') || note.timer === false)
            note.timer = 3000;

        if (!note.hasOwnProperty('fullscreen'))
            note.fullscreen = false;

        Promise.resolve().then(() => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.ADD_NOTIFICATION,
                data: note,
            });
        });
        
    },

    success:(message, fullscreen) => {
        Promise.resolve().then(() => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.ADD_NOTIFICATION,
                data: {
                    type: 'success',
                    body: message,
                    uuid: uuid(),
                    show: true,
                    timestamp: moment(),
                    sticky: fullscreen,
                    fullscreen: fullscreen,
                    additionalInfo : false,
                    timer: 3000,
                },
            });
        });
    },

    alert:(message, fullscreen) => {
        Promise.resolve().then(() => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.ADD_NOTIFICATION,
                data: {
                    type: 'alert',
                    body: message,
                    uuid: uuid(),
                    show: true,
                    timestamp: moment(),
                    sticky: fullscreen,
                    fullscreen: fullscreen,
                    additionalInfo : false,
                    timer: 3000,
                },
            });
        });
    },

    warn:(message, fullscreen) => {
        Promise.resolve().then(() => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.ADD_NOTIFICATION,
                data: {
                    type: 'alert',
                    body: message,
                    uuid: uuid(),
                    show: true,
                    timestamp: moment(),
                    sticky: true,
                    fullscreen: fullscreen,
                    additionalInfo : false,
                    timer: 3000,
                },
            });
        });
    },

    error:(message, fullscreen) => {
        Promise.resolve().then(() => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.ADD_NOTIFICATION,
                data: {
                    type: 'error',
                    body: message,
                    uuid: uuid(),
                    show: true,
                    timestamp: moment(),
                    sticky: true,
                    fullscreen: fullscreen,
                    additionalInfo : false,
                    timer: 3000,
                },
            });
        });
    },

    removeNotification:(uuid) => {
        Promise.resolve().then(() => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.REMOVE_NOTIFICATION,
                data: uuid,
            });
        });
    },

    apiError:(message, additionalInfo, fullscreen) => {
        var body = 'Connection Error. '+(message || '');
        Promise.resolve().then(() => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.ADD_NOTIFICATION,
                data: {
                    type : 'error',
                    uuid : uuid(),
                    show : true,
                    timestamp : moment(),
                    sticky : true,
                    fullscreen: fullscreen,
                    timer : 3000,
                    body : body,
                    additionalInfo : additionalInfo,
                },
            });
        });
    },




    // addNotification:(data) => {
    //     if (data.type === 'error')
    //         data.sticky = true;

    //     AppDispatcher.dispatch({
    //         actionType: ActionTypes.ADD_NOTIFICATION,
    //         data: data
    //     });
    // },

    // success:(msg) => {
    //     NotificationActions.addNotification({
    //         type : 'success',
    //         body : msg
    //     });
    // },

    // alert:(msg) => {
    //     NotificationActions.addNotification({
    //         type : 'alert',
    //         body : msg
    //     });
    // },

    // error:(msg) => {
    //     NotificationActions.addNotification({
    //         type : 'error',
    //         body : msg
    //     });
    // },

    // removeNotification:() => {
    //     AppDispatcher.dispatch({
    //         actionType: ActionTypes.REMOVE_NOTIFICATION
    //     });
    // }
}

export default NotificationActions;


// WEBPACK FOOTER //
// ./ui_src/app/actions/NotificationActions.jsx